import { i18nEaiCodebooks } from 'models/i18n';

// ==============================|| I18N EN CODEBOOKS ||============================== //

const enEaiCodebooks: i18nEaiCodebooks = {
  INDIVIDUAL: { title: 'Individual' },
  ORGANISATION: { title: 'Organisation' },
  PRODUCER: { title: 'Producer' },
  CONSUMER: { title: 'Consumer' },
  PROSUMER: { title: 'Self-consumer' },
  SUPPLIER: { title: 'Supplier' },
  AGGREGATOR: { title: 'Agregator' },
  ELECTRICITY_STORAGE_OPERATOR: {
    title: 'Electricity storage operator'
  },
  ENERGY_COMMUNITY: { title: 'Energy community' },
  BUYER: { title: 'Buyer' },
  OWN: { title: 'Self' },
  TRANSFERRED: { title: 'Transferred' },
  MARKET_PARTICIPANT: {
    title: 'Market participant',
    caption:
      'According to the Act on Energy (owner of production or consumption equipment, administrator of the balance group)'
  },
  SERVICE_PROVIDER: {
    title: 'Service provider',
    caption:
      'Entity established for the purpose of providing services to market participants'
  },
  LEVEL_0: {
    title: 'Level 0'
  },
  LEVEL_1: {
    title: 'Level 1'
  },
  LEVEL_2: {
    title: 'Úroveň 2',
    caption: 'Todo'
  },
  PRODUCTION_OPTIMIZATION: {
    title: 'Production optimization'
  },
  PRODUCTION_OPTIMIZATION_DELIVERY_POINT: {
    title: 'Optimization of production at the OOM level'
  },
  PRODUCTION_OPTIMIZATION_BALANCING_GROUP: {
    title: 'Optimization of production at the balance group level'
  },
  RESERVED_CAPACITY_GUARDING: {
    title: 'Reserved capacity guarding'
  },
  DEVICE_PRODUCTION_PLAN_DAILY: {
    title: 'Product plan on an daily basis'
  },
  DEVICE_PRODUCTION_PLAN_HOURLY: {
    title: 'Product plan on an hourly basis'
  },
  ACTIVE: {
    title: 'Active'
  },
  INACTIVE: {
    title: 'Inactive'
  },
  BLOCKED: {
    title: 'Blocked'
  },
  ENABLED: {
    title: 'Enabled'
  },
  DISABLED: {
    title: 'Disabled'
  },
  OKTE_ISZO: {
    title: 'OKTE ISZO'
  },
  OKTE_ISOT: {
    title: 'OKTE ISOT'
  },
  DAMAS: {
    title: 'DAMAS'
  },
  SUPPLY_POINT: { title: 'Supply Point' },
  OFFTAKE_POINT: { title: 'Offtake Point' },
  LOCAL_DISTRIBUTION_SYSTEM: { title: 'Local Distribution System' },
  INSTALLED: { title: 'Installed' },
  NOT_INSTALLED: { title: 'Not installed' },
  PRODUCTION: { title: 'Production device' },
  CONSUMPTION: { title: 'Consumption device' },
  FVE: { title: 'FVE' },
  BESS: { title: 'BESS' },
  MVE: { title: 'MVE' },
  KJG: { title: 'KJG' },
  ENTIRE_AVAILABLE_CONSUMPTION_POWER_SWITCH: {
    title: 'Entire available consumption power switch'
  },
  AVAILABLE_CONSUMPTION_POWER_STAGES_SWITCH: {
    title: 'Available consumption power stages switch'
  },
  LINEAR_CONTINUOUS_CONSUMPTION_POWER_CHANGE_FIXED: {
    title: 'Fixed linear continuous consumption power change'
  },
  LINEAR_CONTINUOUS_CONSUMPTION_POWER_CHANGE_ADJUSTABLE: {
    title: 'Adjustable linear continuous consumption power change'
  },
  FIXED_CONSUMPTION_PROFILE: {
    title: 'Fixed consumption profile'
  },
  NONLINEAR_CONTINUOUS_CONSUMPTION_POWER_CHANGE: {
    title: 'Nonlinear continuous consumption power change'
  },
  AMORPHOUS: { title: 'Amorphous' },
  POLYCRYSTALLINE: { title: 'Polycrystalline' },
  MONOCRYSTALLINE: { title: 'Monocrystalline' },
  REDOX: { title: 'Redox' },
  LITHIUM: { title: 'Lithium' },
  FIXED_PRICE: { title: 'Fix' },
  INDEXED_PRICE: { title: 'Index' },
  VALID: { title: 'Active' },
  NOT_VALID: { title: 'Inactive' },
  DELETED: { title: 'Deleted' },
  NOT_DELETED: { title: 'Not deleted' },
  ALL: { title: 'All' }
};

export default enEaiCodebooks;
